import React from 'react';
import { connect } from 'react-redux';

const ChatFrame = ({ config: { ChatBot_FrameUrl: url } }) => {
    const frameStyle = {
        width: '0px',
        height: '0px',
        background: 'transparent',
        position: 'fixed',
        margin: '0px',
        right: '0px',
        bottom: '0',
        border: 'none',
        overflow: 'hidden',
        display: 'block',
        zIndex: '999999',
        borderRadius: '0px',
        boxShadow: 'none',
    };

    if (!url) return null;
    console.log('%cChatFrame.js line:24 object', 'color: #00cc0a;', url);
    return (
        <iframe
            id="insync-iframe"
            title="insync-iframe"
            src={url}
            style={frameStyle}
            referrerPolicy="origin"
            sandbox="allow-scripts allow-modals allow-popups allow-same-origin"
        >
            <p>Your browser does not support iframes.</p>
        </iframe>
    );
};

export default connect((state) => {
    return state?.app;
})(ChatFrame);
